import { forEach } from 'lodash';
import {
  ADD_ADMIN_WALLET_BALANCE_SUCCEED,
  FETCH_ADMIN_BALANCE_SUCCEED,
  FETCH_ADMIN_WALLET_SUCCEED,
  FETCH_ALL_ERR_ERC20_SUCCEED,
  FETCH_ALL_ERR_TOMO_ERC20_SUCCEED,
} from '../actions/admin_wallet/action_types';

export default (
  state = {
    adminWallets: [],
    adminBalances: [],
    errERC20s: [],
  }, action,
) => {
  switch (action.type) {
    // fetch order history
    case ADD_ADMIN_WALLET_BALANCE_SUCCEED:
      return {
        ...state,
      };
    case FETCH_ADMIN_BALANCE_SUCCEED:
      return {
        ...state,
        adminBalances: action.data,
      };
    case FETCH_ADMIN_WALLET_SUCCEED:
      forEach(action.data, (item) => {
        item.key = item.address;
      });
      return {
        ...state,
        adminWallets: action.data,
      };
    case FETCH_ALL_ERR_ERC20_SUCCEED:
      forEach(action.data, (item) => {
        item.key = item.address;
      });
      return {
        ...state,
        errERC20s: action.data,
      };
    case FETCH_ALL_ERR_TOMO_ERC20_SUCCEED:
      forEach(action.data, (item) => {
        item.key = item.address;
      });
      return {
        ...state,
        errERC20s: action.data,
      };
    default:
      return {
        ...state,
      };
  }
};
